// TODO Maybe we should only add constants that are used more than 1 place in here...

import { SubstitutionGroupsResponseDTO } from '../dto/profile/suggestion-rules/suggestion-rules-dto';

// Default debounce time.
export const DEFAULT_DEBOUNCE_MIN_TIME = 300;
// Error code for SessionID has timed out.
export const SESSIONID_TIMEOUT = 699665;
// Error code for something wrong with sessionID.
export const SESSIONID_NOT_VALID = 164887;
// Base profile.
export const BASE_PROFILE_SETTINGS = {
  language: 'en-GB',
  name: 'profile name',
  settings: {
    dictionaryType: 'Extended',
    userLanguage: 'en',
    numberOfWords: 10,
    numberOfTopicWords: 10,
    voiceId: 'mv_en_crb',
    wildCards: true,
    useContext: true,
    predictNextWord: true,
    showHomophones: true,
    showSpelling: true,
    minWordLength: 1,
    maxWordLength: 40,
    minPrefixLength: 3,
    minSpellingLength: 3,
    voiceSpeed: 1,
    substitutionRules: [],
    myTerms: [],
    writeLetterName: false,
    writeLetterSound: false,
    writeWord: false,
    writeSentence: false,
    readForward: true,
    highlightWord: true,
    dictionaryLanguage: 'en',
    topicDictionaryIds: [],
  },
};
// Suggestions supported languages.
export const SUGGESTION_LANGUAGE_CODES = [
  'en-GB',
  'da-DK',
  'nl-NL',
  'nn-NO',
  'sv-SE',
  'nb-NO',
];
// Represents the minimum speed allowed.
export const MIN_SPEED = 0.25;
// Represents the maximum speed allowed.
export const MAX_SPEED = 8;
// Regex that matches everything that is not alphanumeric or diacritics.
export const REGEX_WITH_DIACRITICS = /[^A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9]/gimu;

export const SUGGESTION_RULES_DATA: SubstitutionGroupsResponseDTO[] = [
  {
    index: 1,
    name: 'Vokaler',
    subGroups: [
      {
        index: 1,
        name: 'Vokalen a',
        rules: [
          {
            index: 1,
            written: 'a',
            alternative: 'e',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'e',
            alternative: 'a',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'æ',
            alternative: 'a',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'a',
            alternative: 'er',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'ar',
            alternative: 'er',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'ra',
            alternative: 're',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'a',
            alternative: 'æ',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 8,
            written: 'an',
            alternative: 'en',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'a',
            alternative: 'ar',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 'ar',
            alternative: 'a',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 2,
        name: 'Vokaltrappe æ - e - i',
        rules: [
          {
            index: 1,
            written: 'æ',
            alternative: 'e',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'e',
            alternative: 'æ',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'i',
            alternative: 'e',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'e',
            alternative: 'i',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'æ',
            alternative: 'i',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 6,
            written: 'i',
            alternative: 'æ',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 3,
        name: 'Vokaltrappe ø - y',
        rules: [
          {
            index: 1,
            written: 'y',
            alternative: 'ø',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 2,
            written: 'ø',
            alternative: 'y',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 4,
        name: 'Vokaltrappe å - o - u',
        rules: [
          {
            index: 1,
            written: 'o',
            alternative: 'u',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 2,
            written: 'å',
            alternative: 'u',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'u',
            alternative: 'o',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'u',
            alternative: 'å',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 5,
            written: 'å',
            alternative: 'o',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'o',
            alternative: 'å',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 5,
        name: 'Andre vokalforvekslinger e - o - ø - u - y',
        rules: [
          {
            index: 1,
            written: 'o',
            alternative: 'ø',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'y',
            alternative: 'u',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'u',
            alternative: 'y',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'ø',
            alternative: 'e',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: false,
      },
    ],
    defaultEnabled: true,
  },
  {
    index: 2,
    name: 'Diftonger',
    subGroups: [
      {
        index: 1,
        name: 'Diftonger ej - eg - ig',
        rules: [
          {
            index: 1,
            written: 'ai',
            alternative: 'ig',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'aj',
            alternative: 'ej',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'ig',
            alternative: 'ej',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'aj',
            alternative: 'eg',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'eg',
            alternative: 'ig',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 6,
            written: 'ig',
            alternative: 'eg',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 7,
            written: 'ai',
            alternative: 'ej',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'ej',
            alternative: 'ig',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 9,
            written: 'eg',
            alternative: 'ej',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 10,
            written: 'aj',
            alternative: 'ig',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'ej',
            alternative: 'eg',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 12,
            written: 'ag',
            alternative: 'ej',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 13,
            written: 'ag',
            alternative: 'eg',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 2,
        name: 'Diftonger af - au - av',
        rules: [
          {
            index: 1,
            written: 'au',
            alternative: 'af',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'av',
            alternative: 'au',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'au',
            alternative: 'av',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'av',
            alternative: 'af',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: false,
      },
      {
        index: 3,
        name: 'Diftonger - flere fejltyper',
        rules: [
          {
            index: 1,
            written: 'j',
            alternative: 'g',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'i',
            alternative: 'j',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'øg',
            alternative: 'øj',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'i',
            alternative: 'g',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 5,
            written: 'u',
            alternative: 'v',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 6,
            written: 'øj',
            alternative: 'øg',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 7,
            written: 'g',
            alternative: 'j',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'j',
            alternative: 'i',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: true,
  },
  {
    index: 3,
    name: 'Enkeltkonsonant til dobbeltkonsonant',
    subGroups: [
      {
        index: 1,
        name: 'Vis dobbeltkonsonant',
        rules: [
          {
            index: 1,
            written: 'k',
            alternative: 'kk',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'n',
            alternative: 'nn',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 't',
            alternative: 'tt',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'c',
            alternative: 'cc',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'f',
            alternative: 'ff',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'l',
            alternative: 'll',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'r',
            alternative: 'rr',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'd',
            alternative: 'dd',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'g',
            alternative: 'gg',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 'm',
            alternative: 'mm',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'p',
            alternative: 'pp',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 12,
            written: 's',
            alternative: 'ss',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 13,
            written: 'b',
            alternative: 'bb',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: true,
  },
  {
    index: 4,
    name: 'Dobbeltkonsonant til enkeltkonsonant',
    subGroups: [
      {
        index: 1,
        name: 'Vis enkeltkonsonant',
        rules: [
          {
            index: 1,
            written: 'nn',
            alternative: 'n',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'bb',
            alternative: 'b',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'mm',
            alternative: 'm',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'll',
            alternative: 'l',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'kk',
            alternative: 'k',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'tt',
            alternative: 't',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'ss',
            alternative: 's',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'gg',
            alternative: 'g',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'rr',
            alternative: 'r',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 'ff',
            alternative: 'f',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'pp',
            alternative: 'p',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 12,
            written: 'dd',
            alternative: 'd',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 13,
            written: 'cc',
            alternative: 'c',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: false,
  },
  {
    index: 5,
    name: 'Stumme konsonanter',
    subGroups: [
      {
        index: 1,
        name: 'Stumme konsonanter - udeladelser',
        rules: [
          {
            index: 1,
            written: 'v',
            alternative: 'hv',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'l',
            alternative: 'lg',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'r',
            alternative: 'rd',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'n',
            alternative: 'nd',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'l',
            alternative: 'ld',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 's',
            alternative: 'ds',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 's',
            alternative: 'ps',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 't',
            alternative: 'dt',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'o',
            alternative: 'or',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 'j',
            alternative: 'hj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'y',
            alternative: 'yg',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 12,
            written: 'u',
            alternative: 'ug',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 13,
            written: 'n',
            alternative: 'dn',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 14,
            written: 'u',
            alternative: 'ud',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 15,
            written: 's',
            alternative: 'sc',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 16,
            written: 'ø',
            alternative: 'øg',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 17,
            written: 'i',
            alternative: 'ig',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 18,
            written: 'a',
            alternative: 'ag',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 19,
            written: 'g',
            alternative: 'gd',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 20,
            written: 'l',
            alternative: 'lv',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 2,
        name: 'Stumme konsonanter - tilføjelser',
        rules: [
          {
            index: 1,
            written: 'ig',
            alternative: 'i',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 2,
            written: 'lg',
            alternative: 'l',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'yg',
            alternative: 'y',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'ug',
            alternative: 'u',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 5,
            written: 'ld',
            alternative: 'l',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 6,
            written: 'ds',
            alternative: 's',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 7,
            written: 'rd',
            alternative: 'r',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 8,
            written: 'dt',
            alternative: 't',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 9,
            written: 'nd',
            alternative: 'n',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 10,
            written: 'hj',
            alternative: 'j',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'hv',
            alternative: 'v',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: true,
  },
  {
    index: 6,
    name: 'Konsonantklynger - udeladelser',
    subGroups: [
      {
        index: 1,
        name: 'r i konsonantklynger',
        rules: [
          {
            index: 1,
            written: 'd',
            alternative: 'dr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'v',
            alternative: 'vr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'g',
            alternative: 'gr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'b',
            alternative: 'br',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 't',
            alternative: 'tr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'sp',
            alternative: 'spr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'sk',
            alternative: 'skr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'p',
            alternative: 'pr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'k',
            alternative: 'kr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 'st',
            alternative: 'str',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'f',
            alternative: 'fr',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 2,
        name: 'j i konsonantklynger',
        rules: [
          {
            index: 1,
            written: 'p',
            alternative: 'pj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'sk',
            alternative: 'skj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'k',
            alternative: 'kj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'st',
            alternative: 'stj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'f',
            alternative: 'fj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 's',
            alternative: 'sj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'd',
            alternative: 'dj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'g',
            alternative: 'gj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'b',
            alternative: 'bj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 't',
            alternative: 'tj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 'm',
            alternative: 'mj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 12,
            written: 'sp',
            alternative: 'spj',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 3,
        name: 'v i konsonantklynger',
        rules: [
          {
            index: 1,
            written: 'k',
            alternative: 'kv',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'sk',
            alternative: 'skv',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 't',
            alternative: 'tv',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'd',
            alternative: 'dv',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 4,
        name: 'l i konsonantklynger',
        rules: [
          {
            index: 1,
            written: 'b',
            alternative: 'bl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'k',
            alternative: 'kl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 's',
            alternative: 'sl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'g',
            alternative: 'gl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'f',
            alternative: 'fl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'p',
            alternative: 'pl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'sp',
            alternative: 'spl',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 5,
        name: 'n i konsonantklynger',
        rules: [
          {
            index: 1,
            written: 'k',
            alternative: 'kn',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 's',
            alternative: 'sn',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'g',
            alternative: 'gn',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'f',
            alternative: 'fn',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 6,
        name: 'Andre konsonantklynger',
        rules: [
          {
            index: 1,
            written: 's',
            alternative: 'sp',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'n',
            alternative: 'ng',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 's',
            alternative: 'sm',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 's',
            alternative: 'st',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: false,
  },
  {
    index: 7,
    name: 'Konsonantforvekslinger',
    subGroups: [
      {
        index: 1,
        name: 'b - p',
        rules: [
          {
            index: 1,
            written: 'b',
            alternative: 'p',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'b',
            alternative: 'pp',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'p',
            alternative: 'b',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'sb',
            alternative: 'sp',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'bb',
            alternative: 'pp',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 2,
        name: 'd - t',
        rules: [
          {
            index: 1,
            written: 'd',
            alternative: 'tt',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 2,
            written: 'd',
            alternative: 't',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'dd',
            alternative: 'tt',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'sd',
            alternative: 'st',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 't',
            alternative: 'd',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 3,
        name: 'g - k',
        rules: [
          {
            index: 1,
            written: 'kk',
            alternative: 'gg',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'g',
            alternative: 'kk',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'sg',
            alternative: 'sk',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'gg',
            alternative: 'kk',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'k',
            alternative: 'g',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'g',
            alternative: 'k',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'k',
            alternative: 'gg',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 4,
        name: 'c - k',
        rules: [
          {
            index: 1,
            written: 'k',
            alternative: 'c',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'kr',
            alternative: 'chr',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'chr',
            alternative: 'kr',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 4,
            written: 'ko',
            alternative: 'co',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'ka',
            alternative: 'ca',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 5,
        name: 'c - s',
        rules: [
          {
            index: 1,
            written: 'sj',
            alternative: 'ch',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 's',
            alternative: 'c',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 3,
            written: 'si',
            alternative: 'ci',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'sy',
            alternative: 'cy',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'c',
            alternative: 's',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 6,
            written: 'sj',
            alternative: 'ci',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'se',
            alternative: 'ce',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 6,
        name: 'Andre konsonantforvekslinger',
        rules: [
          {
            index: 1,
            written: 'sj',
            alternative: 'j',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 2,
            written: 'ld',
            alternative: 'll',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'nd',
            alternative: 'nn',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 's',
            alternative: 'z',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 5,
            written: 'sje',
            alternative: 'ge',
            applyAt: 'FromStart',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'x',
            alternative: 'ks',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 's',
            alternative: 'x',
            applyAt: 'FromStart',
            defaultEnabled: false,
          },
          {
            index: 8,
            written: 'll',
            alternative: 'ld',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'v',
            alternative: 'g',
            applyAt: 'InsideOnly',
            defaultEnabled: false,
          },
          {
            index: 10,
            written: 'nn',
            alternative: 'nd',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: true,
  },
  {
    index: 8,
    name: 'Endelser og ombytninger',
    subGroups: [
      {
        index: 1,
        name: 'Vis andre endelser',
        rules: [
          {
            index: 1,
            written: 'rer',
            alternative: 're',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'tion',
            alternative: 'sion',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'sjon',
            alternative: 'tion',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'ene',
            alternative: 'ende',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'sion',
            alternative: 'tion',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 6,
            written: 'tion',
            alternative: 'ssion',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 7,
            written: 'ende',
            alternative: 'ene',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 8,
            written: 'de',
            alternative: 'ede',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 9,
            written: 'er',
            alternative: 'rer',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 10,
            written: 'sjon',
            alternative: 'sion',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 11,
            written: 're',
            alternative: 'rer',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
      {
        index: 2,
        name: 'Ombytninger',
        rules: [
          {
            index: 1,
            written: 'er',
            alternative: 're',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 2,
            written: 'ng',
            alternative: 'gn',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 3,
            written: 'ed',
            alternative: 'de',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 4,
            written: 'gn',
            alternative: 'ng',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
          {
            index: 5,
            written: 'nj',
            alternative: 'gn',
            applyAt: 'InsideOnly',
            defaultEnabled: true,
          },
        ],
        defaultEnabled: true,
      },
    ],
    defaultEnabled: false,
  },
];
// Represents speech type for text to speech.
export const TTS = 'TTS';
// Represents speech type for letter name.
export const LETTER_NAME = 'LetterName';
// Represents speech type for letter sound.
export const LETTER_SOUND = 'LetterSound';

// Sorted dictionary ids for norwegian language.
export const DICTIONARY_NORWEGIAN_LANGUAGE_SORTED_IDS = [
  2,
  7,
  14,
  12,
  13,
  23,
  16,
  20,
  15,
  19,
  11,
  1,
  9,
  26,
  18,
  25,
  29,
  28,
  32,
  27,
  30,
  8,
  33,
  17,
  22,
  24,
  35,
  21,
  34,
  31,
  10,
  36,
];
// Sorted dictionary ids for swedish language.
export const DICTIONARY_SWEDISH_LANGUAGE_SORTED_IDS = [
  8,
  33,
  17,
  22,
  24,
  35,
  21,
  34,
  31,
  10,
  1,
  9,
  26,
  18,
  25,
  29,
  28,
  32,
  27,
  30,
  2,
  7,
  14,
  12,
  13,
  23,
  16,
  20,
  15,
  19,
  11,
  36,
];
// Sorted dictionary ids for all languages except norwegian and swedish languages.
export const DICTIONARY_MAJOR_LANGUAGE_SORTED_IDS = [
  36,
  1,
  9,
  26,
  18,
  25,
  29,
  28,
  32,
  27,
  30,
  2,
  7,
  14,
  12,
  13,
  23,
  16,
  20,
  15,
  19,
  11,
  8,
  33,
  17,
  22,
  24,
  35,
  21,
  34,
  31,
  10,
];
